import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'numberToWeeksdays',
    pure: false
})
export class NumberToWeekdaysPipe implements PipeTransform {
  private translateService = inject(TranslateService);


  /**
   * Diese Pipe erhält eine Zahl von 0 bis 127. In binärer Schreibweise hat diese Zahl dann 7 Stellen aus 0 oder 1.
   * Diese Stellen stehen für die 7 Wochentage und beschreiben zu welchen Wochentragen die Öffnungszeit (Period) gehört.
   * Die Pipe erzeugt dann dir entsprechende String-Darstellung.
   *
   * Beispiel:
   * 15 >> 0001111 >> [1,1,1,1,0,0,0] >> MO-DO
   * 31 >> 0011111 >> [1,1,1,1,1,0,0] >> MO-FR
   * 16 >> 0010000 >> [0,0,0,0,1,0,0] >> FR
   * 23 >> 0010111 >> [1,1,1,0,1,0,0] >> MO-MI, FR
   *
   * @param value
   * @returns string
   */
  transform(value: number): string {
    const binaryString: string[] = value.toString(2).split('').reverse();
    const openingDays: string[] = [];
    /**
     * Variable, ob und ab wann es mehrere aufeinanderfolgende Tage mit 1 gibt.
     */
    let rangeStart = -1;

    for (let i = 0; i < binaryString.length; i++) {
      if (binaryString[i] === '1') {
        // Wenn der Tag eine 1 hat und noch kein Start mehrer 1en gesetzt ist, wird dieser Tag als Start gesetzt.
        if (rangeStart === -1) {
          rangeStart = i;
        }
      } else {
        // Wenn der Tag keine 1 hat und mind. der vorherige Tag eine 1 hatte, wird der Zeitraum von allen aufeinanderfolgenden 1en bis zum vorherigen Tag als Zeitfenster gesetzt.
        if (rangeStart !== -1) {
          openingDays.push(this.translate(rangeStart, i - 1));
          rangeStart = -1;
        }
      }
    }

    // Wenn der letzte Tag eine 1 hatte, wird der Zeitraum von allen aufeinanderfolgenden 1en bis diesem Tag als Zeitfenster gesetzt.
    if (rangeStart !== -1) {
      openingDays.push(this.translate(rangeStart, binaryString.length - 1));
    }
    return openingDays.join(', ');

  }

  /**
   * Die Funktion erhält die Indizes zweier Tage und erzeugt den entsprechen String inkl. Übersetzungen.
   *
   * Beispiele
   * 1,1 >> MO
   * 1,3 >> MO-MI
   * 3,6 >> MI-SA
   * 7,7 >> SO
   *
   * @param rangeStart
   * @param rangeEnd
   * @private
   */
  private translate(rangeStart: number, rangeEnd: number): string {
    const days = [
      'core.weekday.mon',
      'core.weekday.tue',
      'core.weekday.wed',
      'core.weekday.thu',
      'core.weekday.fri',
      'core.weekday.sat',
      'core.weekday.sun'
    ];
    if(rangeStart === rangeEnd) {
      return this.translateService.instant(days[rangeStart]);
    }
    return this.translateService.instant(days[rangeStart]) + ' - ' + this.translateService.instant(days[rangeEnd]);
  }
}
